export default function isSelectionActive() {
    const selection = window.getSelection();
    return selection.toString().length !== 0;
}
